// 手机号验证
 function isvalidPhone(str) {
  const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
  return reg.test(str)
}


// 手机号验证
function isvalidEmail(str) {
  const reg =  /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
  return reg.test(str)
}

var validPhone=(rule, value,callback)=>{
  if (!value){
    callback(new Error('请输入电话号码'))
  }else  if (!isvalidPhone(value)){
    callback(new Error('请输入正确的11位手机号码'))
  }else {
    callback()
  }
}

var validPhone2=(rule, value,callback)=>{  //可以为空
  if(value==''||value==null){
    callback();
  } else if (!isvalidPhone(value)){
    callback(new Error('请输入正确的11位手机号码'))
  }else {
    callback()
  }
}

var validEmail=(rule, value,callback)=>{
  if (!value){
    callback(new Error('邮箱不能为空'))
  }else  if (!isvalidEmail(value)){
    callback(new Error('请输入正确的邮箱格式'))
  }else {
    callback()
  }
}
var validEmail2=(rule, value,callback)=>{ //可以为空
  if(value==''||value==null){
    callback();
  }else  if (!isvalidEmail(value)){
    callback(new Error('请输入正确的邮箱格式'))
  }else {
    callback()
  }
}
export{ validPhone,validPhone2 ,validEmail,validEmail2,isvalidPhone,isvalidEmail}



// WEBPACK FOOTER //
// ./src/common/validate.js